import React from 'react'
import { LoadingIndicator } from 'components/loading'
import { useStyles } from './overlay.css'
import { constants } from 'consts'

const Overlay = (props) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div className={classes.loading}>
        {props.loading && <LoadingIndicator color='white' />}
        <div>{props.localize('common.winelist')}</div>
        <div>{props.message || props.localize('common.momentPlease')}</div>
        {props.showLoginLink && <div><a className={classes.login} href={`${constants.authentication.AUTHORITY_URI}/Account/Login`}>{props.localize('common.loginAgain')}</a></div>}
      </div>
    </div>
  )
}

export default Overlay
